import React from 'react'
import { Box, Group, Text } from '@mantine/core'

interface CountdownBoxProps {
  value: string
}

export const CountdownBox: React.FC<CountdownBoxProps> = ({ value }) => (
  <Box
    style={{
      background: '#FF5A5A',
      color: '#fff',
      borderRadius: 6,
      padding: '2px 8px',
      fontWeight: 700,
      fontSize: 14,
      textAlign: 'center',
      display: 'inline-block',
      minWidth: 32,
    }}
  >
    {value}
  </Box>
)

interface CountdownProps {
  days: string
  hours: string
}

export const Countdown: React.FC<CountdownProps> = ({ days, hours }) => (
  <Group gap={4} align="center" style={{ marginTop: 16, flexWrap: 'nowrap' }}>
    <Text style={{ color: '#A89B9B', fontSize: 14, fontWeight: 500, whiteSpace: 'nowrap' }}>年终盛典开奖倒计时</Text>
    <CountdownBox value={days} />
    <Text style={{ color: '#A89B9B', fontSize: 14, fontWeight: 500 }}>天</Text>
    <CountdownBox value={hours} />
    <Text style={{ color: '#A89B9B', fontSize: 14, fontWeight: 500 }}>时</Text>
  </Group>
)
